import { useContext } from 'react'

import { TableContext } from 'shared/components/table'

export const withTableController =
  ({ id, name = 'table' }) =>
  () => {
    const controller = useContext(TableContext)
    return { [name]: controller.getTable(id) }
  }
